const isLocalhost = window.location.hostname === 'localhost';

export const globalVariables = {
  ssoDomain: process.env.SSO_DOMAIN,
  apiDomain: process.env.KONG_API_DOMAIN,
  appId: process.env.ECA_APP_ID,
  userData: process.env.USER_DATA,
  caDomain: (isLocalhost ? location.origin : process.env.CA_DOMAIN || '') + '/', //proxy to 'https://ca.nonprod.3d4medical.com/'
  pendoApiKey: process.env.PENDO_API_KEY,
  userAccount: 'https://myaccount.elsevier.com/',
  cookieSrc: process.env.ONETRUST_SRC || '',
  cookieId: process.env.ONETRUST_ID || '',
  caDeeplinkDomain: process.env.CA_DOMAIN?.includes('nonprod')
    ? 'https://cert.complete-anatomy.com'
    : 'https://complete-anatomy.com',
  caWebStore: process.env.WEB_STORE,
  pendoTutorialId: process.env.PENDO_TUTORIAL_ID || '',
  eolsDomain: process.env.EOLS_DOMAIN,
};
